import BillingAddress from './billing_address';
import ShippingAddress from './shipping_address';
import {setOrFallbackValue} from './helper';
import { isEmpty } from '../../../../lib/utilities';
export default class Order {
    constructor(props) {
        this.addressBilling = new BillingAddress(props.addressBilling);
        this.addressShipping = new ShippingAddress(props.addressShipping);
        this.email = setOrFallbackValue(props, 'email', '');
        this.expenses = !isEmpty(setOrFallbackValue(props, 'expenses', {})) ?
        props.expenses.map((expense) => {
                return new Expenses(expense);
            }) : [];
        this.firstName = setOrFallbackValue(props, 'firstName', '');
        this.lastName = setOrFallbackValue(props, 'lastName', '');
        this.orderItems = !isEmpty(setOrFallbackValue(props, 'orderItems', {})) ?
        props.orderItems.map((orderItem) => {
                return new OrderItems(orderItem);
            }) : [];
        this.orderNumber = setOrFallbackValue(props, 'orderNumber', '');
        this.paymentMethod = !isEmpty(setOrFallbackValue(props, 'paymentMethod', {})) ?
            new PaymentMethod(props.paymentMethod) : {};
        this.paymentRedirectUrl = setOrFallbackValue(props, 'paymentRedirectUrl', null);
    }
}

class Expenses {
    constructor(props) {
        this.type = setOrFallbackValue(props, 'type', '');
        this.amount = setOrFallbackValue(props, 'amount', '');
        this.amountWithoutTax = setOrFallbackValue(props, 'amountWithoutTax', '');
    }
}

class PaymentMethod {
    constructor(props) {
        this.key = setOrFallbackValue(props, 'key', '');
        this.name = setOrFallbackValue(props, 'name', '');
    }
}

class OrderItems {
    constructor(props) {
        this.itemCost = setOrFallbackValue(props, 'itemCost', '');
        this.location = {
            state: props.location.state ? props.location.state : '',
        };
        this.product = props.product ? {
            brand: props.product.brand ? props.product.brand : '',
            group: props.product.group ? props.product.group : '',
            imageUrl: props.product.imageUrl ? props.product.imageUrl : '',
            loadIndex: props.product.loadIndex ? props.product.loadIndex : '',
            model: props.product.model ? props.product.model : '',
            productCode: props.product.productCode ? props.product.productCode : '',
            productType: props.product.productType ? props.product.productType : '',
            profile: props.product.profile ? props.product.profile : '',
            qualityCategory: props.product.qualityCategory ? props.product.qualityCategory : '',
            rimSize: props.product.rimSize ? props.product.rimSize : '',
            runflat: props.product.runflat ? props.product.runflat : false,
            speedIndex: props.product.speedIndex ? props.product.speedIndex : '',
            starRating: props.product.starRating ? props.product.starRating : '',
            usage: props.product.usage ? props.product.usage : '',
            width: props.product.width ? props.product.width : '',
        } : {};
        this.quantity = setOrFallbackValue(props, 'quantity', '');
        this.retailPrice = setOrFallbackValue(props, 'retailPrice', '');
        this.status = setOrFallbackValue(props, 'status', '');
        this.stock = {
            idSupplierStock: props.stock.idSupplierStock ? props.stock.idSupplierStock : '',
        };
    }
}
